(function () {
    'use strict';

    angular
        .module('emails')
        .controller('OverviewController', OverviewController);

    OverviewController.$inject = ['$scope','$uibModal','$compile','CampaignsService', 'Webworker','$interval', 'TimezoneService','$sce','$q'];

    function OverviewController($scope,$uibModal,$compile,CampaignsService, Webworker, $interval, TimezoneService, $sce, $q) {
        var vm = this;

        /*PAGINATION*/
        vm.campaignsSending       = [];
        $scope.trustAsHtml        = function(string) {
                                        return $sce.trustAsHtml(string);
                                    };
        vm.pauseButton            = true;
        vm.timezoneList           = [];
        vm.timezoneSelected       = '';
        vm.playButton             = true;
        vm.cancelButton           = true;
        vm.dateField              = false;
        vm.showDateField          = showDateField;
        vm.pageChanged            = pageChanged;
        vm.setPage                = setPage;
        vm.totalItems             = [];
        vm.to                     = [];
        vm.currentPage            = null;
        vm.itemsPerPage           = [];
        vm.page                   = 1;
        vm.count                  = [];

        vm.query                  = {};
        vm.campaigns              = [];
        vm.sendDate                         = '';
        vm.sendDateOptions                  = {
            autoUpdateInput: true,
            autoApply:true,
            singleDatePicker: true,
            timePicker: true,
            timePickerIncrement: 30,
            locale: {
                format: 'MM/DD/YYYY h:mm A',
                cancelLabel: 'Close'
            }
        };

        /* Calendar Functions */
        vm.alertOnEventClick    = alertOnEventClick;
        vm.timezoneList         = [];
        vm.selectTimezone       = [];
        vm.alertOnDrop          = alertOnDrop;
        vm.alertOnResize        = alertOnResize;
        vm.addRemoveEventSource = addRemoveEventSource;
        vm.addEvent             = addEvent;
        vm.remove               = remove;
        vm.renderCalender       = renderCalender;
        vm.eventRender          = eventRender;
        vm.getCampaigns         = getCampaigns;
        vm.getCampaignsSchedule = getCampaignsSchedule;
        vm.openEmailModal       = openEmailModal;
        vm.cancelScheduleModal  = cancelScheduleModal;
        vm.changeDate           = changeDate;
        vm.changeStatus         = changeStatus;
        vm.getCompaniesCount    = getCompaniesCount;
        vm.openHtmlModal        = openHtmlModal;
        vm.selectTimezone       = selectTimezone;

        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();

        // EasyPieChart
        vm.chart = {
            percent: 65,
            options: {
                animate: {
                    duration: 200,
                    enabled: true
                },
                barColor: '#3b99d8',
                scaleColor: false,
                lineWidth: 10,
                lineCap: 'circle'
            }
        };

        vm.calendar = {
            height: 450,
            editable: true,
            header:{
                left: 'prev,next today',
                center: 'title',
                right: 'month,agendaWeek,agendaDay'
            },
            eventClick : vm.openEmailModal,
            eventDrop : vm.alertOnDrop
        };
        vm.calendar.events = [
            // {
            //     title: 'Email to CC Representatives',
            //     start: new Date(y, m, 7),
            //     allDay: false,
            //     className: 'label-info',
            //     id: 123
            // },
            // {
            //     title: 'StudyUSA - REMINDER - 1 DAY',
            //     start: new Date(y, m, d+1, 4, 0),
            //     allDay: false,
            //     className: 'label-info',
            //     id: 1234
            // },
            // {
            //     title: 'Australian Pavilions - SANTIAGO',
            //     start: new Date(y, m, d+1, 14, 0),
            //     allDay: false,
            //     className: 'label-info',
            //     id: 12345
            // },
            // {
            //     title: 'London fair Itinerary & Important Info',
            //     start: new Date(y, m, d+20, 20, 0),
            //     allDay: false,
            //     className: 'label-info',
            //     id: 123456
            // }
        ];
        /* alert on eventClick */
        function alertOnEventClick( date, jsEvent, view){
            //vm.alertMessage = (date.title + ' was clicked ');
        }

        function showDateField() {
            vm.dateField = true;
        }
        function changeStatus(event, status) {
            vm.query = {};
            vm.query['status'] = status;
            vm.query['event_id'] = event.id;
            CampaignsService.updateCampaignStatus(vm.query).then(function(response){
                    event.status = status;
            }).catch(function(err) {
            });
        }

        function changeDate(event)
        {
            vm.query = {};
            vm.query['event_start'] = vm.sendDate;
            vm.query['timezone'] = vm.timezoneSelected;
            vm.query['event_id'] = event.id;
            CampaignsService.updateCampaignDate(vm.query).then(function(response){
                vm.calendar.events = [];
                vm.getCampaignsSchedule();
                //vm.calendar.events[response.data.id] = new Date(response.data.start);
            }).catch(function(err) {
            });
        }
        /* alert on Drop */
        function alertOnDrop(event, delta, revertFunc, jsEvent, ui, view){
            vm.query = {};
            vm.alertMessage = ('Event Dropped to make dayDelta ' + delta);
            vm.query['event_start'] = event.start;
            vm.query['event_id'] = event.id;
            CampaignsService.updateCampaignDate(vm.query).then(function(response){
                vm.campaigns = response.data;
            }).catch(function(err) {
            });
            // console.log(vm.alertMessage);
            // console.log(event);
        }
        /* alert on Resize */
        function alertOnResize(event, delta, revertFunc, jsEvent, ui, view ){
            vm.alertMessage = ('Event Resized to make dayDelta ' + delta);

        }
        /* add and removes an event source of choice */
        function addRemoveEventSource(sources,source) {
            var canAdd = 0;
            angular.forEach(sources,function(value, key){
                if(sources[key] === source){
                    sources.splice(key,1);
                    canAdd = 1;
                }
            });
            if(canAdd === 0){
                sources.push(source);
            }
        }
        /* add custom event*/
        function addEvent(data) {

            vm.calendar.events.splice(data.id,0,{
                id : data.id,
                title: data.title,
                start: new Date(data.campaign_send_date),
                date : data.campaign_send_date,
                sent_total : data.sent_total,
                total : data.total,
                clicked_total : data.clicked_total,
                opened_total : data.opened_total,
                template : data.template,
                status : data.status,
                className: ['openSesame']
            });
        }
        /* remove event */
        function remove(index) {
            vm.calendar.events.splice(index,1);
        }
        /* Change View */
        function changeView(view,calendar) {
            uiCalendarConfig.calendars[calendar].fullCalendar('changeView',view);
        }
        /* Change View */
        function renderCalender(calendar) {
            if(uiCalendarConfig.calendars[calendar]){
                uiCalendarConfig.calendars[calendar].fullCalendar('render');
            }
        }
        /* Render Tooltip */
        function eventRender( event, element, view ) {
            element.attr({'tooltip': event.title,
                'tooltip-append-to-body': true});
            $compile(element)($scope);
        }
        /* */
        function getCampaigns(){
            vm.query = [];
            vm.query['status'] = 'Sending';
            vm.query['source'] = 'overview';
            CampaignsService.getCampaigns(vm.query).then(function(response){
                vm.campaignsSending = response.data;
            }).catch(function(err) {
            });
        }

        function selectTimezone() {
            var defer = $q.defer();
            TimezoneService.getAll().then(function(response){
                vm.timezoneList =  response.data;
                defer.resolve(response.data);
            }).catch(function(err) {
                defer.resolve(err);
            });
            return defer.promise;
        }

        function getCampaignsSchedule(){
            vm.query = [];
            vm.query['source'] = 'overview';
            CampaignsService.getCampaigns(vm.query).then(function(response){
                angular.forEach(response.data,function(value){
                    vm.addEvent(value);
                });
            }).catch(function(err) {
            });
        }

        function getCompaniesCount(){
            vm.query = [];
            vm.query['status'] = 'Sending';
            vm.query['source'] = 'overview';
            CampaignsService.getCampaigns(vm.query).then(function(response){
                return vm.count = response.data;
            }).catch(function(err) {
            });
        }

        // function alertOnEventClick( date, jsEvent, view){
        //     console.log(date);
        //     console.log(jsEvent);
        //     console.log(view);
        //     //vm.alertMessage = (date.title + ' was clicked ');
        // }
        function openEmailModal(event){
            vm.email = event;
            vm.dateField = false;
            vm.modal = $uibModal.open({
                templateUrl: 'templates/emails/overview/schedule-modal.html',
                scope: $scope,
                resolve: {
                    emailDate : function () {
                        return vm.email;
                    }
                }
            });
        }

        function cancelScheduleModal(event){
            $uibModal.open({
                templateUrl: 'templates/emails/overview/confirmationCancelSchedule/template.modal.html',
                controller: 'confirmationCancelScheduleController',
                controllerAs:'confirmationCancelSchedule',
                resolve:
                    {
                        overviewController : function () {
                            return vm;
                        },
                        event : function () {
                            return event;
                        }
                    }
            });
        }
        function activate() {
            vm.getCampaignsSchedule();
            vm.getCampaigns();
            vm.selectTimezone();
            // var count = {};
            // var aux = {};
            // var response = [];
            // $interval(function() {
            //     response = vm.getCompaniesCount();
            //     console.log(vm.count);
            //     angular.forEach(vm.count,function(value) {
            //         if(typeof count[value.id] === 'undefined')
            //             count[value.id] = 0;
            //         count[value.id] = value.total_email_sent;
            //         if(typeof aux[value.id] === 'undefined') {
            //             aux[value.id] = -1
            //         }
            //         console.log(count[value.id], aux[value.id]);
            //         if (count[value.id] !== aux[value.id]) {
            //             vm.calendar.event = [];
            //             aux[value.id] = count[value.id];
            //             var myWorker = Webworker.create(vm.getCampaigns());
            //             myWorker.run().then(function () {
            //             });
            //         }
            //     });
            // }, 5000);

            //vm.selectVirtualFair();
        }

        function openHtmlModal(event) {
            $uibModal.open({
                templateUrl: 'templates/emails/overview/openCampaignHtml/template.modal.html',
                controller: 'openCampaignHtmlController',
                controllerAs:'openCampaignHtml',
                windowClass:'app-modal-window2',
                resolve:
                    {
                        campaign : function () {
                            return event;
                        }
                    }
            });

        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }
        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        activate();
    }

})();